// import Cookies from 'js-cookie'
const state = {
  currObj: {}
}
const mutations = {
  SET_CURROBJ: (state, currobj) => {
    state.currobj = currobj
  }
}
const actions = {
  toggleCURROBJ({ commit }, obj) {
    commit('SET_CURROBJ')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
